/** Tutorial / tour progress in localStorage (per browser user). */

const FALLBACK_SEEN = 'pp_tutorial_seen';

function seenKey(userId) {
  return userId ? `pp_tutorial_seen:${userId}` : FALLBACK_SEEN;
}

function tourDoneKey(userId, tourId) {
  const uid = userId || 'anon';
  return `pp_tour_done:${uid}:${tourId}`;
}

/** Catalog intro already shown (first Help menu presentation). */
export function hasSeenTutorial(userId) {
  try {
    return localStorage.getItem(seenKey(userId)) === '1';
  } catch {
    return false;
  }
}

export function markTutorialSeen(userId) {
  try {
    localStorage.setItem(seenKey(userId), '1');
  } catch {
    /* ignore */
  }
}

export function clearTutorialSeen(userId) {
  try {
    localStorage.removeItem(seenKey(userId));
  } catch {
    /* ignore */
  }
}

export function hasCompletedTour(userId, tourId) {
  try {
    return localStorage.getItem(tourDoneKey(userId, tourId)) === '1';
  } catch {
    return false;
  }
}

export function markTourCompleted(userId, tourId) {
  try {
    localStorage.setItem(tourDoneKey(userId, tourId), '1');
  } catch {
    /* ignore */
  }
}

export function clearTourCompleted(userId, tourId) {
  try {
    localStorage.removeItem(tourDoneKey(userId, tourId));
  } catch {
    /* ignore */
  }
}
